import './styles/index.scss';
import { CnActionSheet as ActionSheet } from './action-sheet';
import open from './open';
// 由于open中调用了 ActionSheet，所以需要将 ActionSheet 前置做国际化
export var CnActionSheet = ActionSheet;
CnActionSheet.show = open;
